import { PatientDashboardActionTypes } from './../constants/ApiConstants';

const initialState = {
  loading: false,
  app_data: null
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PatientDashboardActionTypes.get_CheckUserPasswordStatus.REQUEST:
      return {
        ...state,
        passwordExpiryMessage: null,
        passwordExpiryColorCode: null,
      };
    case PatientDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS:
      return {
        ...state,        
        passwordExpiryMessage: payload.passwordExpiryStatus.status ? payload.passwordExpiryStatus.message : null,
        passwordExpiryColorCode: payload.passwordExpiryStatus.status ? payload.passwordExpiryStatus.colorCode : null,
      };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/dashboard/reducers/ClientDashboardReducer.js